import { React } from "react";
import { useAuth } from "providers/AuthContext";
import {ORSMasterListing} from "components/globals/ORSMasterListing"

const CarNotes = ({ entry }) => {
	const { userInfo, isFetching } = useAuth();

  const notes = {
		params: {
			elementId: "carNotes",
			headingTitle: `Car Notes`,
			headingButtonUrl: "",
			headingButtonText: "",
			apiPath: `note/car/${entry?.internal_id}`,
			omit: "none",
			limit: "12",
			type: "post", 
			pagination: true,
		},
		displayOptions: {
			layout: "row",
			yoursBadge: false,
			typeBadge: true,
			categoryBadge: false,
			userBadge: false,
			carBadge: false,
			carDetails: false,
			dateDetails: true,
			rowColumns: true,
			mobileCarousel: false,
			likes: true,
		}
	};


	return (
		<>
			{!isFetching && entry.user_id === userInfo?.user_id && (
				<>
					<div className="flex items-center bg-green py-2 pl-3 pr-1 text-black block mb-3 text-[12px] ">
						Car Notes are only visible to you
					</div>
					<ORSMasterListing 
						params={notes.params} 
						displayOptions={notes.displayOptions} 
					/>
				</>
			)}
		</>
	);
};

export default CarNotes;
